import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef, Fragment } from 'react'
import Api from '../../../../_helpers/Api'
import { Checkbox, FormControlLabel, Switch, Tab, Tabs } from '@mui/material'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'
import uploadImage from '@/assets/img/storage/icons/upload.svg'
import MultiSelect from "react-multi-select-component"
import { useAuthDataContext } from '../../../../_providers/Auth'
import { useParams } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import Error from '../../../modals/messages/Error'
import infoIcon from '../../../../assets/img/icons/info-black.png'
import Help from '../../../partials/Help'
import popupHeadImage from '@/assets/img/settings/icons/popup-head.svg'
import PhoneField from '@/components/partials/PhoneField'
import Skeleton from 'react-loading-skeleton'
import AppliancesCategoriesPricing from '../../../partials/AppliancesCategoriesPricing'
import BlueSwitch from '@/components/partials/BlueSwitch'
import deleteIcon from "@/assets/img/reservations/icons/delete.svg"
import CategoryBrandSelect from './CategoryBrandSelect'
import '@/assets/scss/pages/selfemployed.scss'
import PermissionCheckboxList from '@/components/common/PermissionCheckboxList'

function AddOrEditEmployee(props, ref) {

    const params = useParams()
    const auth = useAuthDataContext()

    const defaultData = {
        active: true,
        selectedPerms: [],
        selectedAppliances: [],
        parts_from: 'tech',
        pricing_method: '1',
        visit_time_price_type: 'FIXED',
        pricing_type: '1'
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: defaultData,
        image: null,
        perms: [],
        appliances: [],
        labourPriceTypes: [],
        labourPrices: {},
        loading: false,
    })
    const [activeTab, setActiveTab] = useState('info')
    const [validations, setValidations] = useState(null)
    const [loadingData, setLoadingData] = useState(false)
    const [statusPriceRules, setStatusPriceRules] = useState([])
    const [categoryPriceRules, setCategoryPriceRules] = useState([])
    const [initialStatuses, setInitialStatuses] = useState([])
    const [finalStatuses, setFinalStatuses] = useState([])

    const maxEmployeesErrorModal = useRef(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: defaultData,
            }))
            setStatusPriceRules([])
            setCategoryPriceRules([])
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                loading: false,
                data: defaultData,
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (!popup.editId) return

        Api.get('partners/categories/prices?external_tech_id=' + popup.editId)
            .then(res => {
                if (res.data && Object.keys(res.data).length > 0) {
                    setPopup(prev => ({
                        ...prev,
                        labourPrices: res.data
                    }))
                }
            })
    }, [popup.edit])

    useEffect(() => {
        if (popup.edit) {
            setLoadingData(true)

            Api.get(`partners/employees/find?id=${popup.editId}`)
                .then(res => {

                    let data = res.data
                    let perms = res.data.perms || []
                    let appliances = res.data.appliances || []
                    let selectedPerms = []
                    let selectedAppliances = []

                    perms.map(m => {
                        selectedPerms.push({
                            label: m.translation ? m.translation.name : '',
                            value: m.id
                        })
                    })

                    data.selectedPerms = selectedPerms

                    appliances.map(m => {
                        selectedAppliances.push({
                            label: m.translation ? m.translation.name : m.name,
                            value: m.id
                        })
                    })

                    data.selectedAppliances = selectedAppliances

                    setPopup(prev => ({
                        ...prev,
                        data: data,
                    }))

                    setStatusPriceRules(Array.isArray(data.pricing) ? data.pricing : [])
                    setCategoryPriceRules(Array.isArray(data.pricing_by_category)
                        ? data.pricing_by_category.map(rule => ({
                            ...rule,
                            brand_prices: (rule.brand_prices || []).map(b => b.brand_id)
                        }))
                        : [])
                })
                .finally(() => {
                    setLoadingData(false)
                })
        }
    }, [popup.edit])

    useEffect(() => {
        Api.get('partners/employees/permissions?partner_id=' + params.id)
            .then(res => {

                const data = res.data.map(m => {
                    const children = (m.children || []).map(c => {
                        return { label: c.translation ? c.translation.name : c.name, value: c.id, children: [] }
                    })

                    return { label: m.translation ? m.translation.name : m.name, value: m.id, children }
                })
                setPopup(prev => ({ ...prev, perms: data }))
            })


        Api.get('partners/categories/all?partner_id=' + params.id)
            .then(res => {

                let data = []

                res.data.map(m => {
                    data.push({
                        label: m.name,
                        value: m.id
                    })
                })

                // console.log(data);

                setPopup(prev => ({
                    ...prev,
                    appliances: data
                }))
            })

        Api.get('settings/labour-price-types')
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    labourPriceTypes: res.data
                }))
            })

        Api.get('reservations/initial-and-final-statuses')
            .then(res => {
                setInitialStatuses(Array.isArray(res.data?.initial) ? res.data.initial : [])
                setFinalStatuses(Array.isArray(res.data?.final) ? res.data.final : [])
            })
    }, [])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        if (e) {
            e.preventDefault()
        }

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                image: null,
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()


        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'partners/selfemployed/edit'
        } else {
            url = 'partners/selfemployed/add'
        }

        let data = new FormData(e.target)

        if (popup.image && popup.image.file) {
            data.append('image', popup.image.file)
        }


        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide(e)

                // if (popup.editId === auth.id()) {
                auth.refresh()
                // }

                document.getElementById('employee-form').reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        if (input === 'max_employees_reached') {
                            handleHide()

                            let modal = maxEmployeesErrorModal.current

                            modal.open()
                            modal.onClose(() => {
                                handleShow()
                            })
                        }

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: !prev.data[name]
            }
        }))
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleDateChange = e => {
        let name = e.target.name + '_ymd'
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleActiveChange = e => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                active: !prev.data.active
            }
        }))
    }

    const handlePermChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selectedPerms: data
            }
        }))
    }

    const handleAppliancesChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selectedAppliances: data
            }
        }))
    }

    const handleAttachImage = (e) => {
        const file = e.target.files[0]
        if (file) {
            const reader = new FileReader()
            reader.onload = (event) => {
                setPopup(prev => ({
                    ...prev,
                    image: {
                        file: file,
                        tmppath: event.target.result
                    }
                }))
            }
            reader.readAsDataURL(file)
        }
    }

    const handleOpenImage = (e) => {
        e.preventDefault()
        const input = document.getElementById('employee-image')
        input.click()
    }

    function createMarkup(text) {
        return { __html: text }
    }

    const handleLabourPriceChange = e => {
        let name = e.target.name.split('[')[1].replace(']', '')
        let val = e.target.value

        if (name.length) {
            setPopup(prev => ({
                ...prev,
                labourPrices: {
                    ...prev.labourPrices,
                    [name]: {
                        ...prev.labourPrices[name],
                        default: val
                    }
                }
            }))
        } else {
            setPopup(prev => ({
                ...prev,
                labourPrices: {
                    ...prev.labourPrices,
                    default: val
                }
            }))
        }
    }

    const getSelectedLabourPrice = () => {
        if (popup.data && popup.data.labour_price_type_id) {
            let type = popup.labourPriceTypes.filter(t => Number(t.id) === Number(popup.data.labour_price_type_id))[0]
            if (type) {
                return type
            }
        }
        return null
    }

    const selectedLabourPriceIsFixed = () => {
        let type = getSelectedLabourPrice()
        if (type) return type.is_fixed
        return null
    }

    const selectedLabourPriceIsDiagnosticAndLabour = () => {
        let type = getSelectedLabourPrice()
        if (type) return type.is_diagnostic_and_labour
        return null
    }

    const selectedLabourPriceIsHourly = () => {
        let type = getSelectedLabourPrice()
        if (type) return type.is_hourly
        return null
    }

    const addStatusPriceRule = () => {
        setStatusPriceRules(prev => [...prev, { type: '', status_id: '', price: '' }])
    }

    const removeStatusPriceRule = index => {
        setStatusPriceRules(prev => prev.filter((_, i) => i !== index))
    }

    const handleStatusPriceRuleChange = (index, field, value) => {
        setStatusPriceRules(prev => prev.map((rule, i) =>
            i === index
                ? { ...rule, [field]: value, ...(field === 'type' ? { status_id: '' } : {}) }
                : rule
        ))
    }

    const addCategoryPriceRule = () => {
        setCategoryPriceRules(prev => [...prev, { category_id: '', brand_prices: [], price: '' }])
    }

    const removeCategoryPriceRule = index => {
        setCategoryPriceRules(prev => prev.filter((_, i) => i !== index))
    }

    const handleCategoryPriceRuleChange = (index, field, value) => {
        setCategoryPriceRules(prev => prev.map((rule, i) =>
            i === index
                ? { ...rule, [field]: value }
                : rule
        ))
    }

    const handleCategoryBrandChange = (index, selection) => {
        setCategoryPriceRules(prev => prev.map((rule, i) =>
            i === index
                ? { ...rule, category_id: selection.category_id, brand_prices: selection.brand_prices }
                : rule
        ))
    }

    return (
        <>
            <Error
                ref={maxEmployeesErrorModal}
                mainMessage={trans('messages.maxEmployeesReached')}
            />

            <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
                <form id="employee-form" className={`${popup.modal ? 'show' : ''} popup-primary large`} onSubmit={handleSave}>
                    <div className='head-new'>
                        <img src={popupHeadImage} alt="" />
                        <div className='texts'>
                            <h2>
                                {popup.edit ? trans('headings.editEmployee') : trans('headings.addEmployee')}
                            </h2>
                            <p>{trans('subheadings.editEmployee')}</p>
                        </div>
                        <span className='close' onClick={handleHide}>

                        </span>
                    </div>

                    {loadingData ?
                        <Skeleton height={45} count={5} />
                        :
                        <>
                            <Tabs
                                value={activeTab}
                                onChange={(e, newValue) => setActiveTab(newValue)}
                                variant="scrollable"
                                scrollButtons="auto"
                                indicatorColor="primary"
                                textColor="primary"
                                aria-label={trans('selfEmployed.formTabsAria')}
                            >

                                <Tab value="info" label={trans('labels.employeeBasicInfo')} />
                                <Tab value="qual" label={trans('labels.employeeQualifications')} />
                                <Tab value="access" label={trans('labels.employeeAccess')} />
                                <Tab value="payment" label={trans('externalEmployee.payoutType')} /> {/* <Tab value="payment" label="Заплащане" /> */}
                            </Tabs>

                            <div style={{ display: activeTab === 'info' ? 'block' : 'none' }}>
                                <div className='row'>
                                    <div className='col'>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="name">{trans('labels.name')}</label>
                                                <input
                                                    id="name"
                                                    type="text"
                                                    name="name"
                                                    value={popup.data && popup.data.name ? popup.data.name : ''}
                                                    className={validations && validations.name ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col">
                                                <label htmlFor="lastname">{trans('labels.lastname')}</label>
                                                <input
                                                    id="lastname"
                                                    type="text"
                                                    name="lastname"
                                                    value={popup.data && popup.data.lastname ? popup.data.lastname : ''}
                                                    className={validations && validations.lastname ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        {!popup.edit &&
                                            <div className="row">
                                                <div className="col">
                                                    <label htmlFor="password">{trans('labels.password')}</label>
                                                    <input
                                                        id="password"
                                                        type="password"
                                                        name="password"
                                                        className={validations && validations.password ? 'validate' : ''}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <label htmlFor="password_confirmation">{trans('labels.repeatPassword')}</label>
                                                    <input
                                                        id="password_confirmation"
                                                        type="password"
                                                        name="password_confirmation"
                                                        className={validations && validations.password_confirmation ? 'validate' : ''}
                                                    />
                                                </div>
                                            </div>
                                        }

                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="phone">{trans('labels.phone')}</label>
                                                <PhoneField
                                                    codeValue={popup.data?.phone_country_code || '+359'}
                                                    numberValue={popup.data && popup.data.phone ? popup.data.phone : ''}
                                                    codeName="phone_country_code"
                                                    numberName="phone"
                                                    validate={validations && validations.phone}
                                                    onCodeChange={e => {
                                                        setPopup(prev => ({
                                                            ...prev,
                                                            data: {
                                                                ...prev.data,
                                                                'phone_country_code': e.target.value
                                                            }
                                                        }))
                                                    }}
                                                    onNumberChange={e => {
                                                        setPopup(prev => ({
                                                            ...prev,
                                                            data: {
                                                                ...prev.data,
                                                                'phone': e.target.value
                                                            }
                                                        }))
                                                    }}
                                                    placeholder={trans('labels.phone')}
                                                />
                                            </div>
                                            <div className="col">
                                                <label htmlFor="email">{trans('labels.email')}</label>
                                                <input
                                                    id="email"
                                                    type="text"
                                                    name="email"
                                                    value={popup.data && popup.data.email ? popup.data.email : ''}
                                                    className={validations && validations.email ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="work_time_from">{trans('labels.workingHours')}</label>
                                                <div
                                                    className='row'
                                                    style={{
                                                        gap: "5px",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <input
                                                        id="work_time_from"
                                                        type="time"
                                                        name="work_time_from"
                                                        value={popup.data && popup.data.work_time_from ? popup.data.work_time_from : ''}
                                                        className={validations && validations.work_time_from ? 'validate' : ''}
                                                        onChange={handleInputChange}
                                                    />
                                                    -
                                                    <input
                                                        id="work_time_to"
                                                        type="time"
                                                        name="work_time_to"
                                                        value={popup.data && popup.data.work_time_to ? popup.data.work_time_to : ''}
                                                        className={validations && validations.work_time_to ? 'validate' : ''}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col">
                                                <label htmlFor="max_reservations">{trans('labels.maxReservations')}</label>
                                                <input
                                                    id="max_reservations"
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    name="max_reservations"
                                                    value={popup.data && popup.data.max_reservations ? popup.data.max_reservations : ''}
                                                    className={validations && validations.max_reservations ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='col'
                                        style={{
                                            width: "180px",
                                            flexShrink: 0
                                        }}
                                    >
                                        <div className='upload-logo'>
                                            {popup.image ? (
                                                <img
                                                    src={popup.image.tmppath}
                                                    className='uploaded-image'
                                                    alt={trans('labels.image')}
                                                />
                                            ) : popup.data?.avatar && typeof popup.data.avatar === 'string' ? (
                                                <img
                                                    src={popup.data.avatar}
                                                    className='uploaded-image'
                                                    style={{ maxHeight: '150px' }}
                                                    alt={trans('labels.image')}
                                                />
                                            ) : (
                                                <div className='initial-look'>
                                                    <img src={uploadImage} alt="" />
                                                    <b>{trans('labels.picture')}</b>
                                                    <p>{trans('labels.allowedFormats')}</p>
                                                </div>
                                            )}
                                            <div>
                                                <input
                                                    id='employee-image'
                                                    type="file"
                                                    className='webImage'
                                                    onChange={handleAttachImage}
                                                    accept="image/*"
                                                    name='image'
                                                    hidden
                                                />
                                                <button
                                                    className={`button-add button-small ${popup.image || popup.data?.avatar ? '' : 'no-logo'}`}
                                                    onClick={handleOpenImage}
                                                >
                                                    {trans('buttons.attachNewLogo')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="address">{trans('labels.address')}</label>
                                        <input
                                            id="address"
                                            type="text"
                                            name="address"
                                            value={popup.data && popup.data.address ? popup.data.address : ''}
                                            className={validations && validations.address ? 'validate' : ''}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col">
                                        <label htmlFor="voicecall_phone">{trans('labels.voiceCallPhone')}</label>
                                        <PhoneField
                                            codeValue={popup.data?.voicecall_phone_country_code || '+359'}
                                            numberValue={popup.data && popup.data.voicecall_phone ? popup.data.voicecall_phone : ''}
                                            codeName="voicecall_phone_country_code"
                                            numberName="voicecall_phone"
                                            validate={validations && validations.voicecall_phone}
                                            onCodeChange={e => {
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        'voicecall_phone_country_code': e.target.value
                                                    }
                                                }))
                                            }}
                                            onNumberChange={e => {
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        'voicecall_phone': e.target.value
                                                    }
                                                }))
                                            }}
                                            placeholder={trans('labels.voiceCallPhone')}
                                        />
                                    </div>
                                    <div
                                        className="col"
                                        style={{
                                            width: "180px",
                                            flexShrink: 0
                                        }}
                                    >
                                        <label htmlFor="leaving_date">{trans('labels.leaveDate')}</label>
                                        <input
                                            id="leaving_date"
                                            type="date"
                                            name="leaving_date"
                                            value={popup.data && popup.data.leaving_date_ymd ? popup.data.leaving_date_ymd : ''}
                                            className={validations && validations.leaving_date ? 'validate' : ''}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                </div>

                                <div
                                    className='row'
                                    style={{
                                        marginBottom: "10px"
                                    }}
                                >
                                    <div className="col">
                                        <div
                                            className='row'
                                            style={{
                                                alignItems: "center"
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <BlueSwitch
                                                        name="allow_auto_gps_changes"
                                                        value={popup.data?.allow_auto_gps_changes !== null ? Number(popup.data?.allow_auto_gps_changes) : 1}
                                                    />
                                                }
                                                checked={popup.data?.allow_auto_gps_changes !== null ? Number(popup.data?.allow_auto_gps_changes) === 1 : true}
                                                className={validations && validations.allow_auto_gps_changes ? 'validate' : ''}
                                                onChange={handleInputChange}
                                                label={trans('labels.allowAutoGPS')}
                                            />
                                            <Help position="right-center" style={{ marginLeft: '-5px' }}>
                                                <div dangerouslySetInnerHTML={createMarkup(trans('random.allowAutoGPS'))} />
                                            </Help>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <BlueSwitch
                                                    name="active"
                                                    value={popup.data ? popup.data.active ? 1 : 0 : 1}
                                                />
                                            }
                                            checked={popup.data ? popup.data.active ? true : false : true}
                                            className={validations && validations.active ? 'validate' : ''}
                                            onChange={handleActiveChange}
                                            label={trans('labels.active')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: activeTab === 'payment' ? 'block' : 'none' }}>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="payout">{trans('externalEmployee.invoicePeriod')}</label>

                                        <select
                                            name="invoice_period"
                                            value={popup.data?.invoice_period || 'week'}
                                            className={validations && validations.invoice_period ? 'validate' : ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value="week">
                                                {trans('externalEmployee.periodWeek')}
                                            </option>
                                            <option value="month">
                                                {trans('externalEmployee.periodMonth')}
                                            </option>
                                        </select>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="payout">{trans('externalEmployee.paymentTerms')}</label>

                                        <select
                                            name="pay_terms"
                                            value={popup.data?.pay_terms || ''}
                                            className={validations && validations.pay_terms ? 'validate' : ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value="week">
                                                {trans('externalEmployee.periodWeek')}
                                            </option>
                                            <option value="month">
                                                {trans('externalEmployee.periodMonth')}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col">

                                        <label htmlFor="pos">
                                            {trans('externalEmployee.posType')}
                                        </label>

                                        <select
                                            name="pos_type"
                                            value={popup.data?.pos_type || 'COMPANY'}
                                            className={validations && validations.pos_type ? 'validate' : ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value="COMPANY">
                                                {trans('externalEmployee.posTypeCompany')}
                                            </option>
                                            <option value="PRIVATE">
                                                {trans('externalEmployee.posTypePrivate')}
                                            </option>
                                        </select>

                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className='row'>
                                            <div className="col">
                                                <b>
                                                    {trans('selfEmployed.partsPaymentTitle')}
                                                </b>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="payout">{trans('selfEmployed.partsFromTitle')}</label>

                                                <select
                                                    name="parts_from"
                                                    value={popup.data?.parts_from || 'tech'}
                                                    className={validations && validations.parts_from ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="tech">
                                                        {trans('selfEmployed.personalParts')}
                                                    </option>
                                                    <option value="company">
                                                        {trans('selfEmployed.companyParts')}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        {popup.data?.parts_from === 'tech' ?
                                            <div className="row">
                                                <div className="col">

                                                    <label htmlFor="parts_markup_type">
                                                        {trans('externalEmployee.partsMarkupType')}
                                                    </label>

                                                    <select
                                                        name="parts_markup_type"
                                                        value={popup.data?.parts_markup_type || ''}
                                                        className={validations && validations.parts_markup_type ? 'validate' : ''}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">{trans('labels.withoutLabel')}</option>
                                                        <option value="FIXED">
                                                            {trans('externalEmployee.partsMarkupFixed')}
                                                        </option>
                                                        <option value="PERCENT">
                                                            {trans('externalEmployee.partsMarkupPercent')}
                                                        </option>
                                                    </select>

                                                </div>

                                                {(popup.data?.parts_markup_type || "").length ?
                                                    <div
                                                        className="col"
                                                        style={{
                                                            maxWidth: "120px"
                                                        }}
                                                    >

                                                        <label>
                                                            {popup.data.parts_markup_type === 'FIXED'
                                                                ? <>
                                                                    {trans('labels.price')} <Help>{trans('externalEmployee.partsMarkupValueFixed')}</Help>
                                                                </>
                                                                : popup.data.parts_markup_type === 'PERCENT'
                                                                    ? <>
                                                                        {trans('labels.percentage')} <Help>{trans('externalEmployee.partsMarkupValuePercent')}</Help>
                                                                    </>
                                                                    : trans('labels.price')
                                                            }
                                                        </label>
                                                        <div className="input-with-unit">
                                                            <input
                                                                id="parts_markup"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                                name="parts_markup"
                                                                value={popup.data && popup.data.parts_markup ?
                                                                    popup.data.parts_markup
                                                                    :
                                                                    ''
                                                                }
                                                                className={validations && validations.parts_markup ? 'validate' : ''}
                                                                onChange={handleInputChange}
                                                            />
                                                            <span className='unit'>
                                                                {popup.data.parts_markup_type === 'FIXED'
                                                                    ? "EUR"
                                                                    : popup.data.parts_markup_type === 'PERCENT'
                                                                        ? "%"
                                                                        : "EUR"
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                    </>
                                                }
                                            </div>
                                            :
                                            <div className="row">
                                                <div className="col">

                                                    <label htmlFor="commission_type">
                                                        {trans('labels.commission')}
                                                    </label>

                                                    <select
                                                        name="commission_type"
                                                        value={popup.data?.commission_type || ''}
                                                        className={validations && validations.commission_type ? 'validate' : ''}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">{trans('labels.withoutLabel')}</option>
                                                        <option value="FIXED">
                                                            {trans('externalEmployee.partsMarkupFixed')}
                                                        </option>
                                                        <option value="PERCENT">
                                                            {trans('externalEmployee.partsMarkupPercent')}
                                                        </option>
                                                    </select>

                                                </div>

                                                {(popup.data?.commission_type || "").length ?
                                                    <div
                                                        className="col"
                                                        style={{
                                                            maxWidth: "120px"
                                                        }}
                                                    >

                                                        <label>
                                                            {popup.data.commission_type === 'FIXED'
                                                                ? <>
                                                                    {trans('labels.price')} <Help>{trans('externalEmployee.partsMarkupValueFixed')}</Help>
                                                                </>
                                                                : popup.data.commission_type === 'PERCENT'
                                                                    ? <>
                                                                        {trans('labels.percentage')} <Help>{trans('externalEmployee.partsMarkupValuePercent')}</Help>
                                                                    </>
                                                                    : trans('externalEmployee.partsMarkupValue')
                                                            }
                                                        </label>
                                                        <div className="input-with-unit">
                                                            <input
                                                                id="commission_value"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                                name="commission_value"
                                                                value={popup.data && popup.data.commission_value ?
                                                                    popup.data.commission_value
                                                                    :
                                                                    ''
                                                                }
                                                                className={validations && validations.commission_value ? 'validate' : ''}
                                                                onChange={handleInputChange}
                                                            />
                                                            <span className='unit'>
                                                                {popup.data.commission_type === 'FIXED'
                                                                    ? "EUR"
                                                                    : popup.data.commission_type === 'PERCENT'
                                                                        ? "%"
                                                                        : "EUR"
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                    </>
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div style={{
                                        backgroundColor: "#f0f0f0",
                                        width: "1px",
                                        flexShrink: 0,
                                        marginRight: "20px",
                                    }}>
                                    </div>
                                    <div className="col">
                                        <div className='row'>
                                            <div className="col">
                                                <b>
                                                    {trans('random.visitAndPrice')}
                                                </b>
                                            </div>
                                        </div>
                                        {/* {popup.data.allow_visit_price ? */}
                                        <div className="row">
                                            <div className="col">

                                                <label htmlFor="visit_time_price_type">
                                                    {trans('labels.pricingMethod')}
                                                </label>

                                                <select
                                                    name="visit_time_price_type"
                                                    value={popup.data?.visit_time_price_type || ''}
                                                    className={validations && validations.visit_time_price_type ? 'validate' : ''}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="FIXED">
                                                        {trans('externalEmployee.partsMarkupFixed')}
                                                    </option>
                                                    <option value="PERCENT">
                                                        {trans('externalEmployee.partsMarkupPercent')}
                                                    </option>
                                                </select>

                                            </div>

                                            <div
                                                className="col"
                                                style={{
                                                    maxWidth: "120px"
                                                }}
                                            >

                                                <label>
                                                    {popup.data.visit_time_price_type === 'FIXED'
                                                        ? <>
                                                            {trans('labels.price')} <Help>{trans('externalEmployee.visitPriceFixed')}</Help>
                                                        </>
                                                        : popup.data.visit_time_price_type === 'PERCENT'
                                                            ? <>
                                                                {trans('labels.percentage')} <Help>{trans('externalEmployee.visitPricePercent')}</Help>
                                                            </>
                                                            : trans('labels.price')
                                                    }
                                                </label>
                                                <div className="input-with-unit">
                                                    <input
                                                        id="visit_time_price_value"
                                                        type="number"
                                                        min="0"
                                                        step="1"
                                                        name="visit_time_price_value"
                                                        value={popup.data && popup.data.visit_time_price_value ?
                                                            popup.data.visit_time_price_value
                                                            :
                                                            ''
                                                        }
                                                        className={validations && validations.visit_time_price_value ? 'validate' : ''}
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className='unit'>
                                                        {popup.data.visit_time_price_type === 'FIXED'
                                                            ? "EUR"
                                                            : popup.data.visit_time_price_type === 'PERCENT'
                                                                ? "%"
                                                                : "EUR"
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        {/* :
                                            String(popup.data?.pricing_type) === '1' && categoryPriceRules.length === 0 || String(popup.data?.pricing_type) === '2' && statusPriceRules.length === 0 ?
                                                <div
                                                    className="alert warning"
                                                    style={{
                                                        marginBottom: 0,
                                                        width: "100%",
                                                    }}
                                                >
                                                    {trans('messages.allowPricing', { fieldName: trans('selfEmployed.allowVisitPrice') })}
                                                </div>
                                                :
                                                <>
                                                </>
                                        } */}
                                    </div>
                                </div>
                                <hr />

                                <div className="row">
                                    <div className="col">
                                        <b>{trans('labels.pricingRules')}</b>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col" style={{
                                        width: "fit-content",
                                    }}>
                                        <label htmlFor="profit_type">
                                            {trans('labels.pricingMethod')}
                                        </label>

                                        <select
                                            name="pricing_type"
                                            value={popup.data?.pricing_type || '1'}
                                            className={validations && validations.pricing_type ? 'validate' : ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value="1">
                                                {trans('selfEmployed.pricingCategoriesBrands')}
                                            </option>
                                            <option value="2">
                                                {trans('selfEmployed.pricingStatus')}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                {String(popup.data?.pricing_type) === '1' ?
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                {categoryPriceRules.map((rule, index) => (
                                                    <div key={index} className="row" style={{ alignItems: 'flex-end', marginBottom: '8px' }}>
                                                        <div className="col">
                                                            <label>{trans('selfEmployed.categoryAndBrand')}</label>
                                                            <CategoryBrandSelect
                                                                name={`pricings[${index}]`}
                                                                value={{
                                                                    category_id: rule.category_id,
                                                                    brand_prices: rule.brand_prices,
                                                                }}
                                                                onChange={selection => handleCategoryBrandChange(index, selection)}
                                                            />
                                                        </div>
                                                        <div
                                                            className="col"
                                                            style={{
                                                                maxWidth: "200px",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <label>{trans('labels.price')}</label>
                                                            <div className="input-with-unit">
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    name={`pricings[${index}][price]`}
                                                                    value={rule.price}
                                                                    onChange={e => handleCategoryPriceRuleChange(index, 'price', e.target.value)}
                                                                />
                                                                <span className='unit'>
                                                                    EUR
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div style={{ flexShrink: 0, paddingBottom: '2px' }}>
                                                            <button
                                                                type="button" className="button button-remove button-small"
                                                                onClick={() => removeCategoryPriceRule(index)}
                                                                style={{
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    padding: 0,
                                                                    minWidth: "initial",
                                                                    flexShrink: 0,
                                                                }}
                                                            >
                                                                <img
                                                                    src={deleteIcon}
                                                                    alt={trans('buttons.delete')}
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <button type="button" className="button button-add button-small" onClick={addCategoryPriceRule}>
                                            {trans('buttons.add')}
                                        </button>
                                    </>
                                    :
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                {statusPriceRules.map((rule, index) => (
                                                    <div key={index} className="row" style={{ alignItems: 'flex-end', marginBottom: '8px' }}>
                                                        <input type="hidden" name={`status_price_rules[${index}][id]`} value={rule.id || ''} />
                                                        <div className="col">
                                                            <label>{trans('labels.type')}</label>
                                                            <select
                                                                name={`status_price_rules[${index}][type]`}
                                                                value={rule.type}
                                                                onChange={e => handleStatusPriceRuleChange(index, 'type', e.target.value)}
                                                            >
                                                                <option value="" disabled>{trans('labels.choose')}</option>
                                                                <option value="initial">{trans('labels.initialStatus')}</option>
                                                                <option value="final">{trans('labels.finalStatus')}</option>
                                                            </select>
                                                        </div>
                                                        <div className="col">
                                                            <label>{trans('labels.status')}</label>
                                                            <select
                                                                name={`status_price_rules[${index}][status_id]`}
                                                                value={rule.status_id}
                                                                onChange={e => handleStatusPriceRuleChange(index, 'status_id', e.target.value)}
                                                            >
                                                                <option value=""></option>
                                                                {(rule.type === 'initial' ? initialStatuses : rule.type === 'final' ? finalStatuses : []).map(s => (
                                                                    <option key={s.id} value={s.id}>{s.translation?.name || s.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div
                                                            className="col"
                                                            style={{
                                                                maxWidth: "200px",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <label>{trans('labels.price')}</label>
                                                            <div className="input-with-unit">
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    name={`status_price_rules[${index}][price]`}
                                                                    value={rule.price}
                                                                    onChange={e => handleStatusPriceRuleChange(index, 'price', e.target.value)}
                                                                />
                                                                <span className='unit'>
                                                                    EUR
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div style={{ flexShrink: 0, paddingBottom: '2px' }}>
                                                            <button
                                                                type="button" className="button button-remove button-small"
                                                                onClick={() => removeStatusPriceRule(index)}
                                                                style={{
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    padding: 0,
                                                                    minWidth: "initial",
                                                                    flexShrink: 0,
                                                                }}
                                                            >
                                                                <img
                                                                    src={deleteIcon}
                                                                    alt="delete"
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <button type="button" className="button button-add button-small" onClick={addStatusPriceRule}>
                                            {trans('buttons.add')}
                                        </button>
                                    </>
                                }
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="allow_visit_price"
                                                    value="1"
                                                    checked={popup.data.allow_visit_price ? true : false}
                                                    onChange={handleCheckboxChange}
                                                    size='small'
                                                />
                                            }
                                            label={trans('selfEmployed.priceForCancellation')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: activeTab === 'qual' ? 'block' : 'none' }}>
                                <div className="row">
                                    <div className="col">
                                        {popup.appliances.map(appliance => (
                                            <Fragment key={appliance.value}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="appliances[]"
                                                            value={appliance.value}
                                                            checked={popup.data.selectedAppliances.some(s => s.value === appliance.value)}
                                                            onChange={(e) => {
                                                                const isChecked = e.target.checked
                                                                if (isChecked) {
                                                                    handleAppliancesChange([...popup.data.selectedAppliances, appliance])
                                                                } else {
                                                                    handleAppliancesChange(popup.data.selectedAppliances.filter(s => s.value !== appliance.value))
                                                                }
                                                            }}
                                                            size='small'
                                                        />
                                                    }
                                                    label={appliance.label}
                                                />
                                            </Fragment>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: activeTab === 'access' ? 'block' : 'none' }}>
                                <div className="row">
                                    <div className="col">
                                        <div className="checkbox-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
                                            <PermissionCheckboxList perms={popup.perms} selectedPerms={popup.data.selectedPerms} onChange={handlePermChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    <div className="footer align-right">
                        {popup.loading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button className="button" onClick={handleHide}>
                                    {trans('buttons.cancel')}
                                </button>
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.save')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div >
        </>
    )
}

export default forwardRef(AddOrEditEmployee)